module.exports = __webpack_public_path__ + "static/media/loginBackgroundImage.062ec7c6.svg";